import { CustomerChatPresence } from "@buzzeasy/chat-fragment-2";
import { WorkItem } from "@buzzeasy/shared-frontend-utilities";
import { createContext } from "react";
import { Customer } from "../../models/customer";

type WorkItemId = WorkItem["workItemId"];

export interface WorkItemInfo {
  customer?: Customer;
  crmOutboundCustomerIdentifier?: string;
  customerPresence?: CustomerChatPresence | null;
}

export const defaultWorkItemInfo: WorkItemInfo = { customer: undefined, crmOutboundCustomerIdentifier: undefined, customerPresence: null };

export interface WorkItemContextValue {
  workItemInfoDict: Record<WorkItemId, WorkItemInfo | undefined>;
  setInfo(workItemId: WorkItemId, info: WorkItemInfo | ((currentInfo: WorkItemInfo | undefined) => WorkItemInfo)): void;
  removeInfo(workItemId: WorkItemId): void;
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const WorkItemInfoContext = createContext<WorkItemContextValue>(undefined!);
